// Mock data for pakuskapis.lv landing page
// This file will be replaced with real API calls after backend integration

export const companyInfo = {
  name: "Pakuskapis.lv",
  company: "0g Baltics SIA",
  address: "Elizabetes iela 31-8",
  postalCode: "LV-1010",
  city: "Rīga",
  country: "Latvija",
  email: "info@0gbaltics.com",
  operatingSince: 2019
};

export const heroContent = {
  title: "pakuskapis.lv™ risinājumi reāliem lietošanas apstākļiem",
  subtitle: "Piemēroti viedie skapji pašvaldībām, bankām, uzņēmumiem un sabiedriskām iestādēm Latvijā.",
  proofLine: "Darbojamies Latvijā kopš 2019. gada — iekštelpās un āra vidē.",
  ctaText: "Pieprasīt piedāvājumu",
  image: "/api/images/hero1.png"
};

export const useCases = [
  {
    id: 1,
    title: "Pašvaldības un bibliotēkas",
    description: "Dokumentu un grāmatu izsniegšana un atgriešana, iekštelpās un ārā",
    image: "/api/images/usecase_library.png",
    altText: "pakuskapis.lv™ risinājumi bibliotēkām un pašvaldībām Latvijā"
  },
  {
    id: 2,
    title: "Bankas un uzņēmumi",
    description: "Darbinieku un klientu piekļuve, augsta datu drošība",
    image: "/api/images/usecase_bank.png",
    altText: "pakuskapis.lv™ risinājumi bankām un uzņēmumiem"
  },
  {
    id: 3,
    title: "Transports un sabiedriskās vietas",
    description: "Izturīgi pakuskapji stacijām un publiskām zonām",
    image: "/api/images/usecase_transport.png",
    altText: "pakuskapis.lv™ risinājumi transporta stacijām"
  },
  {
    id: 4,
    title: "Pagaidu un sezonāli risinājumi",
    description: "Pludmales, pasākumi, sezonāla izmantošana",
    image: "/api/images/usecase_temporary.png",
    altText: "pakuskapis.lv™ pagaidu risinājumi sezonālai lietošanai"
  },
  {
    id: 5,
    title: "Atslēgu skapji",
    description: "Auto tirgotājiem, birojiem un citiem uzņēmumiem",
    image: "/api/images/usecase_keys.png",
    altText: "pakuskapis.lv™ atslēgu skapji auto tirgotājiem un birojiem"
  },
  {
    id: 6,
    title: "Pēc pasūtījuma risinājumi",
    description: "Nestandarta konfigurācijas jūsu specifiskajām vajadzībām",
    image: "/api/images/usecase_custom.png",
    altText: "pakuskapis.lv™ pēc pasūtījuma risinājumi"
  }
];

export const approachContent = {
  title: "Piemērots konkrētam lietojumam, nevis universāls produkts",
  description: "Mēs sākam ar vidi, lietotājiem un ekspluatācijas prasībām, lai piedāvātu optimālu pakuskapis.lv™ risinājumu. Akumulatori — ja tas ir saprātīgi. Vadi — ja tas ir nepieciešams.",
  image: "/api/images/approach_diagram.png",
  altText: "pakuskapis.lv™ risinājumu pieejas diagramma"
};

export const differencesContent = {
  title: "Izstrādāti darbam, nevis iespaidam",
  image: "/api/images/diff_comparison.png",
  altText: "pakuskapis.lv™ salīdzinājums ar konkurentiem",
  bullets: [
    "Akumulatora risinājumi, ja tas ir pamatoti",
    "Vadu risinājumi, ja nepieciešams",
    "Nav lieku būvdarbu",
    "Prognozējama uzturēšana",
    "Pierādīta darbība Latvijas apstākļos kopš 2019. gada"
  ]
};

export const configurations = [
  { id: 1, name: "Metāla korpuss", image: "/api/images/config_metal.png", altText: "pakuskapis.lv™ metāla konfigurācija" },
  { id: 2, name: "Koka apdare", image: "/api/images/config_wood.png", altText: "pakuskapis.lv™ koka konfigurācija" },
  { id: 3, name: "Stikla elementi", image: "/api/images/config_glass.png", altText: "pakuskapis.lv™ stikla konfigurācija" },
  { id: 4, name: "Tastatūra", image: "/api/images/config_keypad.png", altText: "pakuskapis.lv™ ar tastatūru" },
  { id: 5, name: "RFID", image: "/api/images/config_rfid.png", altText: "pakuskapis.lv™ ar RFID" },
  { id: 6, name: "Smart-ID", image: "/api/images/config_smartid.png", altText: "pakuskapis.lv™ ar Smart-ID" }
];

export const configSectionContent = {
  title: "Standarta platformas ar pielāgojamām konfigurācijām",
  description: "Mēs izmantojam standarta platformas un pielāgojam tās konkrētam lietojumam."
};

export const platformContent = {
  title: "Pārbaudīta platforma operatoriem un lietotājiem",
  images: [
    { id: 1, src: "/api/images/platform_dashboard.png", altText: "pakuskapis.lv™ vadības panelis" },
    { id: 2, src: "/api/images/platform_maintenance.png", altText: "pakuskapis.lv™ uzturēšanas sistēma" },
    { id: 3, src: "/api/images/platform_userflow.png", altText: "pakuskapis.lv™ lietotāja plūsma" }
  ]
};

export const trustContent = {
  title: "Uzticas visā Latvijā",
  proofLine: "100% aprīkoto bibliotēku turpina izmantot mūsu risinājumu.",
  logos: [
    { id: 1, src: "/api/images/logo_01.png", altText: "Bauskas novads" },
    { id: 2, src: "/api/images/logo_02.png", altText: "Cēsu Centrālā Bibliotēka" },
    { id: 3, src: "/api/images/logo_03.png", altText: "Rīgas Centrālā Bibliotēka" },
    { id: 4, src: "/api/images/logo_04.png", altText: "Jelgavas pilsēta" },
    { id: 5, src: "/api/images/logo_05.png", altText: "Kuldīgas Galvenā Bibliotēka" },
    { id: 6, src: "/api/images/logo_06.png", altText: "Liepājas pilsēta" },
    { id: 7, src: "/api/images/logo_07.png", altText: "Rīgas pašvaldība" },
    { id: 8, src: "/api/images/logo_08.png", altText: "Mārupes Novada Bibliotēka" },
    { id: 9, src: "/api/images/logo_09.png", altText: "Mārupes Novada Pašvaldība" },
    { id: 10, src: "/api/images/logo_10.png", altText: "Preiļu Galvenā Bibliotēka" },
    { id: 11, src: "/api/images/logo_11.png", altText: "RCB - Rēzeknes Centrālā Bibliotēka" },
    { id: 12, src: "/api/images/logo_12.png", altText: "Talsu Galvenā Bibliotēka" },
    { id: 13, src: "/api/images/logo_13.png", altText: "Valkas Bibliotēka" },
    { id: 14, src: "/api/images/logo_14.png", altText: "Valmieras novads" }
  ]
};

export const reliabilityContent = {
  title: "Radīti ilgtermiņa ekspluatācijai",
  description: "pakuskapis.lv™ paredzēti ilgstošai darbībai ar skaidru uzturēšanas modeli.",
  image: "/api/images/reliability.png",
  altText: "pakuskapis.lv™ ilgtermiņa uzticamība"
};

export const contactFormContent = {
  title: "Pieprasīt informāciju vai piedāvājumu",
  submitButton: "Nosūtīt pieprasījumu",
  successMessage: "Paldies! Jūsu pieprasījums ir nosūtīts."
};

export const useTypeOptions = [
  { value: "municipality", label: "Pašvaldība" },
  { value: "library", label: "Bibliotēka" },
  { value: "bank", label: "Banka" },
  { value: "enterprise", label: "Uzņēmums" },
  { value: "transport", label: "Transports" },
  { value: "public", label: "Sabiedriska vieta" },
  { value: "temporary", label: "Pagaidu/sezonāls" },
  { value: "other", label: "Cits" }
];

export const footerContent = {
  taglines: [
    "Darbojamies Latvijā kopš 2019. gada",
    "Iekštelpu un āra risinājumi",
    "Publiskie un privātie klienti"
  ]
};

export const headerNav = {
  ctaPrimary: "Pieprasīt piedāvājumu",
  ctaSecondary: "Ieplānot 20 min zvanu"
};
